import { reportClientError } from '../_components/chrome/scripts/DataDogRumScript'

import { shortenShopifyId } from './shortenShopifyId'

type VariantWaitlistResponse = 'success' | 'email-already-registered' | 'unexpected-error'

type VariantWaitlistRequest = {
  email: string
  variantShopifyId: string
}

export const joinVariantWaitlist = async ({
  email,
  variantShopifyId,
}: VariantWaitlistRequest): Promise<VariantWaitlistResponse> => {
  try {
    const clientApiBaseUrl = process.env.NEXT_PUBLIC_CLIENT_API_BASE_URL
    const response = await fetch(`${clientApiBaseUrl}/api/waitlist/waitlists/product`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: email,
        variantId: shortenShopifyId(variantShopifyId),
      }),
    })

    let waitlistRequestResult: VariantWaitlistResponse = 'success'

    if (response.status === 409) {
      // 409 just means that the user is already registered.
      waitlistRequestResult = 'email-already-registered'
    } else if (!response.ok) {
      waitlistRequestResult = 'unexpected-error'
      reportClientError({
        error: new Error('Waitlist request failed'),
        context: {
          scope: 'useWaitlistService sendWaitlistRequest',
          label: '!response.ok',
        },
      })
    }

    return waitlistRequestResult
  } catch (error) {
    reportClientError({
      error,
      context: {
        scope: 'useWaitlistService sendWaitlistRequest',
        label: 'Waitlist request failed',
      },
    })

    return 'unexpected-error'
  }
}
